import React from 'react';

const MessageNotification = ({ message }) => {
  if (!message) return null;

  return (
    <div className="fixed bottom-5 right-5 p-4 bg-indigo-600 text-white rounded-lg shadow-xl z-50 transition duration-300 animate-slide-up">
      {message}
    </div>
  );
};

export default MessageNotification;
